/*
Loons Lab Main Container component
Developed By Roshan
Loons Lab
*/
import React, { Component } from "react";
class MainContainer extends Component {
    static propTypes = {
        children: Node,
    };

    static defaultProps = {
        title: null,

    };



    render() {
        const {
            children
        } = this.props;


        return (

            <div className="pb-8 pt-3 px-3">
                {children}
            </div>


        );
    }
}

export default MainContainer;